export default __webpack_public_path__ + "static/media/2D_Variant02.5b27f7cb.png";